import { getShopifyBaseUrl, isFrench } from 'src/utils/helper'

export const home = `/`

export const accountDetails = '/profile'
export const accountPassword = '/profile/password'
export const resetPassword = '/forgot-password/reset'

export const addressesList = '/addresses'
export const addressesCreate = '/addresses/create'
export const addressesCreateLinkedAccounts = '/linked-accounts/:customerId/addresses/create'
export const addressesEdit = '/addresses/edit/:addressId'
export const addressesEditLinkedAccounts = '/linked-accounts/:customerId/addresses/edit/:addressId'
export const baseAddressEdit = '/addresses/edit/'

export const ordersList = '/orders'
export const ordersListLinkedAccounts = '/linked-accounts/:customerId/orders'
export const ordersDetailsLinkedAccounts = '/linked-accounts/:customerId/orders/:orderId'
export const ordersDetails = '/orders/:orderId'
export const ordersDetailsMissingRx = '/orders/:orderId/rx'
export const ordersDetailsMissingRxOption = '/orders/:orderId/rx/:option'
export const ordersDetailsMissingPD = '/orders/:orderId/pd'
export const orderRMA = '/orders/:orderId/rma'

export const balanceDue = '/balance/:orderId'
export const paymentSuccess = '/payment-success/:orderId'
export const satisfactionSurveyRedirection = '/satisfaction/:lang/:orderId'
export const prescriptionDetails = '/prescription'
export const prescriptionDetailsUpload = '/prescription/upload'
export const prescriptionDetailsUploadLinkedAccounts = '/linked-accounts/:customerId/prescription/upload'
export const prescriptionDetailsUploadOption = '/prescription/upload/:option'
export const prescriptionDetailsUploadOptionLinkedAccounts = '/linked-accounts/:customerId/prescription/upload/:option'
export const pupillaryDistanceDetails = '/pupillary-distance'
export const pupillaryDistanceDetailsUpload = '/pupillary-distance/upload'
export const logout = '/logout'

export const logoutRedirection = (): string =>
  `${getShopifyBaseUrl()}/account/logout`
export const wishlistPage = (): string =>
  `${getShopifyBaseUrl()}/pages/wishlist`
export const cartPage = (): string => `${getShopifyBaseUrl()}/cart`
export const findStorePage = (): string => `${getShopifyBaseUrl()}/blogs/stores`
export const contactUsPage = (): string => `${getShopifyBaseUrl()}/pages/help`
export const faqPage = isFrench() ? "https://bonlook.freshdesk.com/fr/support/home" : "https://bonlook.freshdesk.com/en/support/home"

export const returnPolicyPage = (): string =>
  isFrench()
    ? 'https://bonlook.freshdesk.com/fr/support/solutions/folders/153000412226'
    : 'https://bonlook.freshdesk.com/en/support/solutions/folders/153000412226'

export const helpPage = (): string =>
  isFrench()
    ? 'https://www.bonlook.ca/pages/help?lang=fr'
    : 'https://www.bonlook.ca/pages/help'

export const findNewPairPage = (): string =>
  isFrench()
    ? 'https://www.bonlook.ca/collections/eyeglasses?lang=fr'
    : 'https://www.bonlook.ca/collections/eyeglasses'

export const howToReadRxPage = (): string =>
  isFrench()
    ? 'https://bonlook.zendesk.com/hc/fr-ca/articles/360045219991-Comment-lire-ma-prescription-'
    : 'https://bonlook.zendesk.com/hc/en-us/articles/360045219991-How-do-I-read-my-prescription-'

export const scheduleAppointmentPage = (): string =>
  isFrench()
    ? 'https://www.bonlook.ca/blogs/stores?lang=fr'
    : 'https://www.bonlook.ca/blogs/stores?lang=en'

export const knowRxForOrder = (): string =>
  isFrench()
    ? 'https://bonlook.zendesk.com/hc/fr-ca/articles/360045219251-Que-dois-je-savoir-%C3%A0-propos-de-ma-prescription-avant-de-commander-'
    : 'https://bonlook.zendesk.com/hc/en-us/articles/360045219251-What-do-I-need-to-know-about-my-prescription-before-I-place-an-order-'

export const shopifyHomepage = (country: string, language: string): string =>
  `https://www.bonlook.${
    country === 'CA' ? 'ca' : 'com'
  }/?lang=${language}&redirect=false`

export const shopifyHomepageStaging = (language: string): string =>
  `https://bonlook-ca-staging.myshopify.com/?lang=${language}&redirect=false`
  
export const shopifyLogin = (country: string, language: string): string =>
  `https://www.bonlook.${
    country === 'CA' ? 'ca' : 'com'
  }/account/login/?lang=${language}`

export const shopifyLoginStaging = (language: string): string =>
  `https://bonlook-ca-staging.myshopify.com/account/login/?lang=${language}`
  
export const surveyMonkey = (
  orderId: string,
  lang: string,
  origin: string
): string =>
  `https://www.surveymonkey.com/r/bonlook?orderid=${orderId}&origin=${origin}&lang=${lang}`
